import { useRagnar } from '@mentimeter/ragnar-react';

export const PlaceholderImage = () => {
  const {
    theme: { colors },
  } = useRagnar();

  return (
    <svg
      data-testid="placeholder-image"
      width="100%"
      height="100%"
      viewBox="0 0 638 427"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.879395"
        y="0.354126"
        width="637.083"
        height="426.267"
        rx="9.26667"
        fill={colors.neutralWeakest}
      />
      <ellipse
        cx="337.954"
        cy="171.788"
        rx="18.5333"
        ry="18.5333"
        fill={colors.neutral}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.788 231.412L299.729 191.479L242.971 264.454H305.521L305.521 264.454H395.871L350.696 205.379L330.788 231.412Z"
        fill={colors.neutral}
      />
    </svg>
  );
};
